import { motion } from "framer-motion";
import { CheckCircle2, ShieldCheck } from "lucide-react";

export const VIP_BENEFITS = [
  { n: "01", label: "Your unique founding-member number" },
  { n: "02", label: "Priority access to the OUTLAW V1 launch" },
  { n: "03", label: "Early access to pre-orders before the public" },
  { n: "04", label: "Founder Journal updates from John" },
  { n: "05", label: "Behind-the-scenes development updates" },
];

const pad = (n) => String(n || 0).padStart(3, "0");

export const VipMemberCard = ({ memberNumber, email, resubscribed = false }) => {
  return (
    <motion.div
      data-testid="vip-member-card"
      initial={{ opacity: 0, y: 16, scale: 0.98 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 0.55, ease: [0.2, 0.7, 0.2, 1] }}
      className="relative mx-auto max-w-2xl text-left bg-[#0E0E11] border border-[#F47A20]/35 rounded-sm overflow-hidden shadow-[0_30px_80px_-40px_rgba(244,122,32,0.45)]"
    >
      {/* Grain / corner ticks */}
      <div className="pointer-events-none absolute inset-0 opacity-[0.06]" style={{ backgroundImage: "radial-gradient(rgba(255,255,255,0.6) 1px, transparent 1px)", backgroundSize: "3px 3px" }} />
      <div className="pointer-events-none absolute top-3 left-3 w-3 h-3 border-l border-t border-[#F47A20]/60" />
      <div className="pointer-events-none absolute top-3 right-3 w-3 h-3 border-r border-t border-[#F47A20]/60" />
      <div className="pointer-events-none absolute bottom-3 left-3 w-3 h-3 border-l border-b border-[#F47A20]/60" />
      <div className="pointer-events-none absolute bottom-3 right-3 w-3 h-3 border-r border-b border-[#F47A20]/60" />

      <div className="relative p-7 md:p-9">
        <div className="flex items-center justify-between mb-6">
          <span data-testid="vip-card-brand" className="h-display text-xl text-white">
            ROAD<span className="text-[#F47A20]">RIG</span>
          </span>
          <span className="serial text-[10px] tracking-[0.25em] text-[#F47A20] font-bold flex items-center gap-1.5">
            <ShieldCheck size={12} /> {resubscribed ? "VIP Crew · Reactivated" : "ROADRIG VIP Crew"}
          </span>
        </div>

        <div data-testid="vip-card-headline" className="serial text-[10px] tracking-[0.25em] text-white/45 mb-2">You&rsquo;re In &middot; Founding Member</div>
        <div className="flex items-baseline gap-3 mb-6">
          <span className="serial text-[11px] text-white/50">No.</span>
          <span data-testid="vip-member-number" className="h-display text-5xl md:text-6xl text-white leading-none">
            {pad(memberNumber)}
          </span>
          <span data-testid="vip-member-email" className="ml-auto serial text-[10px] text-white/40 truncate max-w-[55%]">{email}</span>
        </div>

        <div className="border-t border-white/8 pt-5">
          <div className="serial text-[10px] tracking-[0.25em] text-[#F47A20] font-bold mb-3">
            VIP Priority Access &middot; What you get
          </div>
          <ul className="space-y-2.5" data-testid="vip-benefits-list">
            {VIP_BENEFITS.map((b) => (
              <li key={b.n} data-testid={`vip-benefit-${b.n}`} className="flex items-start gap-3 text-white/80 text-sm">
                <span className="serial text-[10px] text-[#F47A20] mt-1 font-bold">{b.n}</span>
                <span>{b.label}</span>
                <CheckCircle2 size={14} className="text-[#F47A20]/70 ml-auto mt-0.5 flex-shrink-0" />
              </li>
            ))}
          </ul>
        </div>

        <p className="serial text-[10px] text-white/45 mt-6 leading-relaxed">
          Hold onto your member number. When the OUTLAW V1 pre-order opens, VIPs go first &mdash; in order.
        </p>
      </div>
    </motion.div>
  );
};

export default VipMemberCard;
